import { url } from '@10000/common'
import QRCode from 'react-qr-code'
import { Box } from '.'

export const QR = ({ size = 250, suffix = '', instanceId, region }) => {
  const host = import.meta.env.VITE_QR_HOST || url.baseUrl
  const value = url.game('shivoo', instanceId, { host, region }) + suffix

  const copy = () => navigator.clipboard.writeText(value)

  return (
    <Box
      background="white"
      size={size}
      p={32}
      onClick={copy}
    >
      <QRCode
        value={value}
        size={size - 64}
      />
    </Box>
  )
}